import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		container: {
			border: `1px solid ${theme.palette.grey[300]}`
		},
		icon: {
			marginRight: theme.spacing(1),
			fontSize: 16
		},
		statusText: {
			flex: 1
		},
		spinner: {
			marginLeft: theme.spacing(1)
		}
	} satisfies Record<string, CSSObject>;
};